import { render, staticRenderFns } from "./blogsDetail.vue?vue&type=template&id=2d5221c4&scoped=true"
import script from "./blogsDetail.vue?vue&type=script&lang=js"
export * from "./blogsDetail.vue?vue&type=script&lang=js"
import style0 from "./blogsDetail.vue?vue&type=style&index=0&id=2d5221c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5221c4",
  null
  
)

export default component.exports